import React, { createContext, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { v4 as uuidv4 } from 'uuid';

const NotificationContext = createContext(undefined);

const NotificationProvider = ({ children }) => {
  const [notifications, setNotifications] = useState([]);
  // Auto remove notifications after 3 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      if (notifications.length) {
        const newArr = notifications;
        newArr.shift();
        setNotifications([...newArr]);
      }
    }, 2000);
    return () => {
      clearInterval(interval);
    };
  }, [notifications]);

  const sendNotification = (notification) => {
    setNotifications([...notifications, { ...notification, id: uuidv4() }]);
  };
  return (
    <NotificationContext.Provider
      value={{
        notifications,
        sendNotification,
      }}
    >
      {children}
    </NotificationContext.Provider>
  );
};

NotificationProvider.propTypes = {
  children: PropTypes.arrayOf(PropTypes.element).isRequired,
};

export { NotificationProvider, NotificationContext };
